import React from 'react';
import { Building2, User, Phone, Mail } from 'lucide-react';

const CompanyInfoForm = ({ customerCompany }) => {
    return (
        <div className="card p-2 space-y-1 rounded-lg" style={{ background: "#FFF", boxShadow: "-8px 0px 40px 0px rgba(0, 0, 0, 0.05)" }}>
            <div className="flex items-center">
                <Building2 size={20} className="mr-2 text-blue-600 flex-shrink-0" />
                <span className="text-base font-medium leading-6">
                    {customerCompany.companyLegalName}
                </span>
            </div>
            <div className="flex items-center">
                <User size={16} className="mr-2 text-orange-500 flex-shrink-0" />
                <span className="text-sm text-gray-600">
                    {customerCompany.contact.contactPersonName}
                </span>
            </div>
            <div className="flex items-center">
                <Phone size={16} className="mr-2 text-green-600 flex-shrink-0" />
                <span className="text-sm text-gray-600">
                    {customerCompany.contact.phone}
                </span>
            </div>
            <div className="flex items-center">
                <Mail size={16} className="mr-2 text-red-500 flex-shrink-0" />
                <span className="text-sm text-gray-600">
                    {customerCompany.contact.email}
                </span>
            </div>
        </div>
    );
};

export default CompanyInfoForm;
